import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoadPersonalData } from '@store/actions';
import * as fromRootStore from '@store/index';
import { selectPersonalDataLoaded } from '@store/selectors/personal-data/personal-data.selectors';
import { CookieService } from 'ngx-cookie-service';
import { catchError, filter, Observable, of, switchMap, tap } from 'rxjs';
import { selectIsClientPersonalInfoLoaded } from 'vg-interaction-model';

@Injectable()
export class ClientGuard {
  constructor(
    private globalStore: Store<fromRootStore.State>,
    private cookieService: CookieService,
  ) {}

  canActivate(): Observable<boolean> {
    if (this.cookieService.get('routeGuard') === 'OFF') {
      this.globalStore.dispatch(LoadPersonalData());
      return of(true);
    }

    return this.isPersonalDataLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false)),
    );
  }

  isPersonalDataLoaded(): Observable<boolean> {
    return this.globalStore.select(selectPersonalDataLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.globalStore.dispatch(LoadPersonalData());
        }
      }),
      switchMap(() =>
        this.globalStore
          .select(selectIsClientPersonalInfoLoaded)
          .pipe(filter((isVGIMPersonalInfoLoaded) => !!isVGIMPersonalInfoLoaded)),
      ),
    );
  }
}
